import { ActivityStatus } from '@sparted/shared-library/business/types';

import { UStatusType } from 'Components/unit/UStatusIndicator/UStatusIndicator';

export const ACTIVITY_STATUS_TYPE_MAP: { [key in ActivityStatus]: UStatusType } = {
  draft: 'invalid',
  upcoming: 'upcoming',
  live: 'valid',
  celebration: 'valid',
  finished: 'valid',
  inactive: 'invalid',
  archived: 'invalid',
};

export const ROUTE_MAP = {
  campaign: '/activity/campaign',
  'breaking-news': '/activity/breaking-news',
};
